import { useState, useEffect, useCallback} from 'react';
import { Dialog, DialogContent, Typography, Paper, Tooltip, IconButton } from '@mui/material'
import Grid from '@mui/material/Grid2';
import { myApi } from '../../../config/axiosConfig';
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import BtnAcciones from '../../../components/plantilla/tabla/BtnAcciones';
import useMediaQuery from '@mui/material/useMediaQuery';
import Swal from 'sweetalert2';

import BorderColorIcon from '@mui/icons-material/BorderColor';
import CrearEditarModal from './CrearEditarModal';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';

const Criteria = ({ idStop, open, onClose, refreshStops }) => {

    const isNonMobile = useMediaQuery("(min-width:600px)");

    const [data, setData] = useState([]);

    const [selected, setSelected] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const handleOpenModal = (criteria = null) => 
    {
        if (criteria) 
        {
            // Editar: criteria trae una fila de la tabla con id de la relación
            setSelected(criteria);
            setIsEditing(true);
        } 
        else 
        {
            // Crear: criteria es null, así que usamos solo el idStop
            setSelected({ id_stop: idStop }); // <-- importante
            setIsEditing(false);
        }
        setModalOpen(true);
    };

    const fetchData = async () => 
    {
        try 
        {
            const response = await myApi.get(`loves/stops/evaluacion/${idStop}`);
            if(response)
            {
                if(response.data.data === 'No hay relaciones')
                    setData([]);
                else
                    setData(response.data.data);
            }
            else
                setData([]);
        } 
        catch(error) 
        {
            console.error('Error fetching criteria:', error);
            setData([]);
        }
    };

    /* const handleEdit = useCallback(async (criteriaRow) => 
    {
        handleOpenModal(data.find(criteria => criteria.id === criteriaRow.id));
        setIsEditing(true);
        setSelected(criteriaRow);
        
    }, []); */
    const handleEdit = useCallback((criteriaRow) => 
    {
        handleOpenModal(criteriaRow);
    }, []);
    
    const handleDelete = useCallback(async (criteriaRow) => 
    {
        const confirm = await Swal.fire({
            title: '¿Está seguro?',
            text: 'Esto eliminará el criterio.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar.',
            cancelButtonText: 'Cancelar.',
            target: document.getElementById('dialog1')
        });

        if (confirm.isConfirmed) 
        {
            try 
            {
                const response = await myApi.delete(`loves/stops/evaluacion/${criteriaRow.id}`);
                if (response.data.success) 
                {
                    Swal.fire({
                        title: 'Eliminado',
                        text: 'Criterio eliminado correctamente.',
                        icon: 'success',
                        target: document.getElementById('dialog1')
                    });
                    if (selected?.id === criteriaRow.id) 
                    {
                        setModalOpen(false);
                        setSelected(null);
                    }
                    refreshStops();
                    fetchData();
                } 
                else 
                {
                    throw new Error('No se pudo eliminar.');
                }
            } 
            catch(err)
            {
                console.error('Error eliminando:', err);
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo eliminar el criterio.',
                    icon: 'error',
                    target: document.getElementById('dialog1')
                });
            }
        }
    }, [fetchData]);

    const columns = [
        {
            field: 'producto', headerName: 'PRODUCTO',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'type', headerName: 'TIPO',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'criterio', headerName: 'CRITERIO',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'acciones',
            headerName: 'ACCIONES',
            type: 'actions',
            width: 150,
            getActions: (params) => [
                <BtnAcciones
                    icon={<BorderColorIcon />}
                    label="Editar"
                    onClick={() => handleEdit(params.row)}
                />,
                <BtnAcciones
                    icon={<DeleteIcon />}
                    label="Eliminar"
                    color="error"
                    onClick={() => handleDelete(params.row)}
                />
            ],
        }
    ];

    useEffect(() => {
        if(idStop) fetchData();
    }, [idStop]);

    return (
        <Dialog id="dialog1" open={open} onClose={onClose} fullWidth maxWidth="sm" scroll="body">
            <DialogContent>
                <Paper sx={{ padding: 2, maxHeight: '70vh', overflowY: 'auto' }}>
                    <Grid container>
                        <Grid size={{ xs: 12, md: 8 }}>
                            <Typography variant="h6" fontWeight="bold" marginBottom={2}>
                                CRITERIOS POR TIENDA
                            </Typography>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 4 }}
                            sx={{
                                display: 'flex',
                                justifyContent: isNonMobile ? 'flex-end' : 'start'
                            }}>
                            <Tooltip title="Agregar">
                                <IconButton
                                    onClick={() => handleOpenModal()}
                                    sx={{ backgroundColor: 'black', color: 'white', marginBottom: 1 }}
                                >
                                    <AddCircleIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        {/** {LISTA DE RELACIONES} */}
                        <Grid size={12}
                            marginTop={1}>
                            <MiTabla
                                columns={columns}
                                data={data}
                                boxHeight="300px"
                            />
                        </Grid>
                        {/* {MODAL EDITAR/CREAR} */}
                        <CrearEditarModal
                            open={modalOpen}
                            onClose={() => setModalOpen(false)}
                            refresh={fetchData}
                            refreshStops={refreshStops}
                            selected={selected}
                            isEditing={isEditing}
                        />
                    </Grid>
                </Paper>
            </DialogContent>
        </Dialog>
    )
}

export default Criteria